import { render, staticRenderFns } from "./ModalSharePost.vue?vue&type=template&id=2e31525a&scoped=true&"
import script from "./ModalSharePost.vue?vue&type=script&lang=js&"
export * from "./ModalSharePost.vue?vue&type=script&lang=js&"
import style0 from "./ModalSharePost.vue?vue&type=style&index=0&id=2e31525a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e31525a",
  null
  
)

export default component.exports